import React from 'react';

import {Helmet} from 'views/module';

import ClientLeadListScene from 'views/scenes/client_lead/list/ClientLeadList';

const ClientLeadList = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Home</title>
      </Helmet>
      <ClientLeadListScene
      />
    </>
  );
};

export default ClientLeadList;
